import { render, staticRenderFns } from "./SendToKronofogden.vue?vue&type=template&id=7a27e848&scoped=true&"
import script from "./SendToKronofogden.vue?vue&type=script&lang=js&"
export * from "./SendToKronofogden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a27e848",
  null
  
)

export default component.exports